'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeSignHashResponse(origin, chain, signedHashes) {
  this.X8 = null;
  this.X7 = null;
  this.X9 = null;
  this.X8 = origin;
  this.X7 = chain;
  this.X9 = signedHashes;
}
export { $c_Lpresto_AgentView$LocalPjeOfficeSignHashResponse as $c_Lpresto_AgentView$LocalPjeOfficeSignHashResponse };
$p = $c_Lpresto_AgentView$LocalPjeOfficeSignHashResponse.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeSignHashResponse;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeSignHashResponse() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeSignHashResponse as $h_Lpresto_AgentView$LocalPjeOfficeSignHashResponse };
$h_Lpresto_AgentView$LocalPjeOfficeSignHashResponse.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AgentView$LocalPjeOfficeSignHashResponse)) {
    if (((this.X8 === x$0.X8) && (this.X7 === x$0.X7))) {
      var x = this.X9;
      var x$2 = x$0.X9;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "LocalPjeOfficeSignHashResponse";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.X8;
      break;
    }
    case 1: {
      return this.X7;
      break;
    }
    case 2: {
      return this.X9;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignHashResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hH)));
}
export { $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignHashResponse as $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignHashResponse };
var $d_Lpresto_AgentView$LocalPjeOfficeSignHashResponse = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeSignHashResponse, "presto.AgentView$LocalPjeOfficeSignHashResponse", ({
  hH: 1,
  bv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeSignHashResponse as $d_Lpresto_AgentView$LocalPjeOfficeSignHashResponse };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Sign-Hash-Response.js.map
